import { PickerView, Popup } from "antd-mobile"
import styled, { createGlobalStyle } from "styled-components"

export const StyledInputNumberFormItem = styled.div`
  --label-width: 70px;

  display: flex;
  position: relative;
  width: 100%;
`
export const StyledLabel = styled.label`
  position: absolute;
  text-align: left;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  font-size: 16px;
  line-height: 160%;
  z-index: 10;
`

export const StyledInput = styled.input<{
  $isError: boolean
  $disabled?: boolean
}>`
  background: var(--white-white-5, rgba(255, 255, 255, 0.049));
  border-radius: 8px;
  backdrop-filter: blur(60px);
  padding: 17.25px 16px;
  padding-left: var(--label-width);
  line-height: 26px;
  font-weight: 700;
  border-radius: 8px;

  border: 1px solid
    ${(props) =>
      props.$isError
        ? "var(--secondary-yellow-amber, #FFC800)"
        : "transparent"};

  color: ${(props) =>
    props.$isError
      ? "var(--secondary-yellow-amber, #FFC800)"
      : props.$disabled
      ? "var(--white-white-50, rgba(255, 255, 255, 0.50))"
      : "var(--Data_Dinner, #14C9C9)"};

  text-align: right;
  width: 100%;
  height: 100%;
  font-size: 16px;

  &:focus,
  &:active,
  &:focus-visible {
    outline: none;
    border: 1px solid
      ${(props) =>
        props.$isError
          ? "var(--secondary-yellow-amber, #FFC800)"
          : "var(--Schemes-Primary, #0da3ba)"};
  }

  &::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: var(--White-White, #fff);
    font-size: 16px;
    font-weight: 400;
    opacity: 0.5;
  }

  &::-moz-placeholder {
    /* Firefox 19+ */
    color: var(--White-White, #fff);
    font-size: 16px;
    font-weight: 400;
    opacity: 0.5;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type="number"] {
    -moz-appearance: textfield;
  }
`

export const PickerPopupStyle = createGlobalStyle`

 @media screen and (min-width: 450px) {
 .adm-popup {
   .adm-mask,
   .adm-popup-body {
     max-width: var(--app-max-width);
     left: 50%;
     transform: translateX(-50%) !important;
     opacity: !important;
      }
    }  
  }
 `

export const StyledPickerView = styled(PickerView)`
  width: 64px;
  padding: 0;
  padding-right: 0;
  background: #2e2e2e;

  .adm-picker-view-mask {
  }

  .adm-picker-header-button {
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 14px; /* 100% */
    letter-spacing: 0.14px;
    color: var(--Schemes-Primary, #0da3ba);
    padding-top: 14px;
  }

  .adm-picker-view-column-item {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 160%;
    color: #fff !important;
  }

  .adm-picker-view-column-item-active {
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: 120%;
    color: #fff;
  }

  .adm-picker-view-mask-middle {
    height: 39px;
    border: none;
  }

  .adm-picker-view-column-item {
    padding: 0;
  }

  .adm-picker-view-column-item-active {
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: 120%;
  }

  .adm-picker-view-mask-top,
  .adm-picker-view-mask-bottom {
    background: #2e2e2e !important;
  }
`

export const PickerText = styled.div`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  width: 10px;
  position: absolute;
  cursor: pointer;
  pointer-events: none;
  color: var(--Schemes-On-Surface-Variant, #69757d);

  span {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
`

export const PickerSelectedMask = styled.div`
  --picker-border: 1px solid rgba(255, 255, 255, 0.2);

  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 39px;

  border-top: var(--picker-border);
  border-bottom: var(--picker-border);
  width: 100%;
  pointer-events: none;
`

export const PickerViewContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  gap: 24px;
`

export const PickerHeader = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
`
export const PickerHeaderTop = styled.div`
  height: 10px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`

export const PickerHeaderBottom = styled.div`
  height: 36px;
  position: relative;
`

export const DoneButton = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 14px; /* 100% */
  letter-spacing: 0.14px;
  color: var(--Schemes-Primary, #0da3ba);
  text-align: center;
  cursor: pointer;
  padding: 16px;
  padding-left: 24px;
  padding-right: var(--app-horizontal-padding);
  position: absolute;
  right: 0;
  bottom: 0;
`

export const DetailsTrailing = styled.div<{ $isUnit?: boolean }>`
  position: absolute;
  right: var(--input-padding-right);
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: var(--White_40, rgba(255, 255, 255, 0.4));
  pointer-events: none;

  ${(props) =>
    props.$isUnit &&
    `
    color: var(--Schemes-Primary, #0DA3BA);
    font-weight: 500;
    `}
`

export const OneDecimalWheelPickerPopup = styled(Popup)`
  .adm-mask {
    background: transparent !important;
  }

  .adm-popup-body {
    background: #2e2e2e;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25),
      0px 1px 7px 0px rgba(0, 0, 0, 0.12);
  }
`
